export const theme = {
  colors: {
    accent: '#4AADA7',
    background: '#C7C7C7',
    black: '#262626',
    box: '#F6F6F6',
    danger: '#FF4218',
    darkBlue: '#095FA4',
    green: '#3EC247',
    grey: '#ACADB6',
    lightBlack: '#404040',
    lightBlueGrey: '#545469',
    lightGrey: '#525268',
    lighterGrey: '#878787',
    link: '#0DA8EA',
    linkVisited: '#086187',
    orange: '#FFA51E',
    primary: '#262626',
    primaryLight: '#303030',
    pink: '#F15BB5',
    purple: '#67388F',
    red: '#FF4218',
    semanticBorder: 'rgba(34,36,38,.15)',
    success: '#4AAD84',
    white: '#FFFFFF',
    yellow: '#FFC700',
    // faded colors
    blueFaded: '#2196F31A',
  },
};
